<div class="p-fluid">
  <p-card>
    <div style="text-align: center; padding: 10em 0">
      <img src="assets/img/logo-sidebar.png" alt="Codex">
    </div>
  </p-card>
</div>
